import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column mmi-colombia w-100 position-relative"
}
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "card-background d-flex flex-column position-relative h-100" }
const _hoisted_5 = { class: "card-body d-flex flex-column flex-grow-1 justify-content-center position-relative" }
const _hoisted_6 = { class: "d-flex justify-content-center ratio ratio-16x9 card-body-video" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "card-footer position-relative text-center lh-1" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "initial-price text-nowrap" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "card-action d-flex position-relative justify-content-center mt-4"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "fas fa-lock ms-1"
}
const _hoisted_15 = {
  key: 1,
  class: "fas fa-spinner fa-spin ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "background-border" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "text-uppercase",
            innerHTML: _ctx.subscriptionName
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "card-body-title text-center" }, null, -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("iframe", {
                src: _ctx.SubscriptionConfig.videos?.buy,
                width: "640",
                height: "360",
                frameborder: "0",
                allow: "autoplay; fullscreen; picture-in-picture",
                allowfullscreen: ""
              }, null, 8, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (!_ctx.isActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", null, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "card-footer-title" }, "Pago Único", -1)),
                    _cache[4] || (_cache[4] = _createTextVNode("  ", -1)),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.SubscriptionConfig.cost) + " " + _toDisplayString(_ctx.SubscriptionConfig.currency), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-nowrap" }, null, -1))
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-end me-5" }, [
                    _createElementVNode("span", { class: "monthly-price" }),
                    _createElementVNode("span", { class: "period-label" })
                  ], -1))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("span", { class: "card-footer-title text-capitalize" }, [
                    _createElementVNode("i", {
                      class: "fas fa-check-circle text-success me-2",
                      "aria-hidden": "true"
                    }),
                    _createTextVNode("Comprado ")
                  ], -1)
                ]))]))
          ]),
          (!_ctx.isOffline && !_ctx.isActive && !_ctx.isLocked)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("button", {
                  class: "btn btn-lg gtr-basic-btn",
                  type: "button",
                  disabled: _ctx.isQuoting || !_ctx.canBuy,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.subscriptionQuote()))
                }, [
                  _cache[8] || (_cache[8] = _createTextVNode("Comprar ", -1)),
                  (!_ctx.canBuy)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                    : _createCommentVNode("", true),
                  (_ctx.isQuoting)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_13),
                (!_ctx.canBuy)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn p-0 ms-3",
                      "data-bs-toggle": "popover",
                      title: "Producto Bloqueado",
                      "data-bs-content": "Para poder adquirir este producto, debes estar inscrito a nuestra <strong>Academia Virtual</strong>.",
                      "data-bs-html": "true",
                      "data-bs-trigger": "focus",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                      ref: "productLocked"
                    }, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("i", { class: "fas fa-info-circle fa-fw" }, null, -1)
                    ]))], 512))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}